// extracted by mini-css-extract-plugin
export default {"imprint":"imprint__w8ME9","content":"content__ffnlH"};